module.exports = new __parcel__URL__("report-categories-skeleton.tpl.5b53a8d3.svg").toString();